<h2 mat-dialog-title class="treeslo-modal-header">
    <span class="treeslo-modal-header__title">{{ 'stores.forms.titles.UpdateThresholdConfiguration' | translate }}</span>
    <button type="button" mat-icon-button class="treeslo-modal-header__close" mat-dialog-close
        [attr.aria-label]="'common.close' | translate">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content>
    <div *ngIf="claimTypesForProvider.length; else noThresholds">
        <form [formGroup]="thresholdForm" class="treeslo-modal-form">
            <div class="store-threshold-dialog__grid">
                <ng-container *ngFor="let claimType of claimTypesForProvider">
                    <div [formGroupName]="claimType.value" class="store-threshold-dialog__row">
                        <div class="store-threshold-dialog__label">
                            {{ "claimsTypes." + claimType.value | translate }}
                        </div>
                        <mat-form-field appearance="outline" class="store-threshold-dialog__field full-width threshold-amount-field"
                            subscriptSizing="dynamic" floatLabel="always">
                            <mat-label>{{ 'stores.forms.fields.thresholdAmount.label' | translate }}</mat-label>
                            <span matTextPrefix>$</span>
                            <input matInput type="number" formControlName="thresholdAmount" />
                        </mat-form-field>
                        <mat-form-field appearance="outline"
                            class="store-threshold-dialog__field full-width threshold-percentage-field" subscriptSizing="dynamic"
                            floatLabel="always">
                            <mat-label>{{ 'stores.forms.fields.thresholdPercentage.label' | translate }}</mat-label>
                            <span matTextPrefix>%</span>
                            <input matInput type="number" formControlName="thresholdPercentage" />
                        </mat-form-field>
                    </div>
                </ng-container>
            </div>
        </form>
    </div>

    <ng-template #noThresholds>
        <p class="store-threshold-dialog__empty">
            {{ 'stores.forms.steps.threshold.noThresholds' | translate }}
        </p>
    </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="treeslo-modal-actions" *ngIf="claimTypesForProvider.length; else noThresholdActions">
        <button mat-stroked-button mat-dialog-close>{{ 'stores.forms.actions.Cancel' | translate }}</button>
        <button mat-flat-button color="primary" type="button" (click)="submitThreshold()"
            [disabled]="thresholdForm.invalid || isThresholdFormCached">
            {{ 'stores.forms.actions.Update' | translate }}
        </button>
    </div>
    <ng-template #noThresholdActions>
        <div class="treeslo-modal-actions">
            <button mat-stroked-button mat-dialog-close>{{ 'common.close' | translate }}</button>
        </div>
    </ng-template>
</mat-dialog-actions>
